import ResponseItemBoxView from './ResponseItemBox.view';
export default ResponseItemBoxView;
